export default ({ request }) => ({
    changeOrderDemandMaterialListApi(data = {}) {
        return request({
            url: '/factory/change/order/demand/material/list',
            method: 'post',
            data
        })
    },
    changeOrderDemandMaterialDetailApi(data = {}) {
        return request({
            url: '/factory/change/order/demand/material/detail',
            method: 'post',
            data
        })
    },
    changeOrderDemandMaterialAddSaveApi(data = {}) {
        return request({
            url: '/factory/change/order/demand/material/add/save',
            method: 'post',
            data
        })
    },
    changeOrderDemandMaterialEditSaveApi(data = {}) {
        return request({
            url: '/factory/change/order/demand/material/edit/save',
            method: 'post',
            data
        })
    },
    changeOrderDemandMaterialDelApi(data = {}) {
        return request({
            url: '/factory/change/order/demand/material/del',
            method: 'post',
            data
        })
    },
})
